import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { CollectionApiService } from "../services/collection-service/collection-api.service";
import { map } from "rxjs";
import { PermissionsService } from "src/app/pages/app-integrator-page/services/permissions.service";
import { UserService } from "../services/user-service/user.service";
import { NavigationSetup } from "../services/navigation-items-service/navigation-setup";

export const editCollectionGuard: CanActivateFn = (_route) => {
    const collectionApiService = inject(CollectionApiService);
    const permissionsService = inject(PermissionsService);
    const userService = inject(UserService);
    const router = inject(Router);
    const collectionId = _route.params['id'];
    
    if(Number.isNaN(Number(collectionId))) {
      console.log('Can not fetch collection details, invalid id: ', collectionId);
      return router.createUrlTree([NavigationSetup.NOT_FOUND.path]);
    }
    
    return collectionApiService.details(collectionId).pipe(
        map((_collectionDetails) => {
            if (permissionsService.canEditCollection(userService.getUser(), _collectionDetails)){
                return true;
            }
            return router.createUrlTree([NavigationSetup.START_PAGE.path]);
        })
    )
};